module.exports = __webpack_public_path__ + "static/media/BlackUs.486ab1d1.jpg";